import { previewTokenReducer } from './previewToken';

export default previewTokenReducer;
